export const orderByHelper = <T>(array: any[], orderField: keyof T) => {
  return array.sort((a, b) => (a[orderField] > b[orderField]) ? 1 : ((b[orderField] > a[orderField]) ? -1 : 0))
}